"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _nicbaseTranslation = require("nicbase-translation");

var _dualListIndividuallySelectable = _interopRequireDefault(require("../dual-list-individually-selectable"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var CommonDualList = /*#__PURE__*/function (_Component) {
  _inherits(CommonDualList, _Component);

  var _super = _createSuper(CommonDualList);

  function CommonDualList(props) {
    var _this;

    _classCallCheck(this, CommonDualList);

    _this = _super.call(this, props);
    _this.selectItems = _this.selectItems.bind(_assertThisInitialized(_this));
    _this.deselectItems = _this.deselectItems.bind(_assertThisInitialized(_this));
    _this.onIndividualItemsClicked = _this.onIndividualItemsClicked.bind(_assertThisInitialized(_this));
    _this.onAllItemsClicked = _this.onAllItemsClicked.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(CommonDualList, [{
    key: "onIndividualItemsClicked",
    value: function onIndividualItemsClicked() {
      var selectedItems = this.props.selectedItems;
      this.props.onChange({
        allItemsSelected: false,
        selectedItems: selectedItems
      });
    }
  }, {
    key: "onAllItemsClicked",
    value: function onAllItemsClicked() {
      var selectedItems = this.props.selectedItems;
      this.props.onChange({
        allItemsSelected: true,
        selectedItems: selectedItems
      });
    }
  }, {
    key: "selectItems",
    value: function selectItems(items) {
      var allItemsSelected = this.props.allItemsSelected;
      var selectedItems = items.map(function (item) {
        return item.id;
      });
      this.props.onChange({
        allItemsSelected: allItemsSelected,
        selectedItems: selectedItems
      });
    }
  }, {
    key: "deselectItems",
    value: function deselectItems(items) {
      var _this$props = this.props,
          allItemsSelected = _this$props.allItemsSelected,
          selectedItems = _this$props.selectedItems;
      var deselectedIds = items.map(function (item) {
        return item.id;
      });
      var filteredItems = selectedItems.filter(function (id) {
        return !deselectedIds.includes(id);
      });
      this.props.onChange({
        allItemsSelected: allItemsSelected,
        selectedItems: filteredItems
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          items = _this$props2.items,
          allItemsSelected = _this$props2.allItemsSelected,
          selectedItems = _this$props2.selectedItems;
      return /*#__PURE__*/_react["default"].createElement(_dualListIndividuallySelectable["default"], {
        textAll: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
          id: "common.all",
          tagName: "span"
        }),
        textSelectIndividually: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
          id: "common.selectIndividually",
          tagName: "span"
        }),
        allItemsSelected: allItemsSelected,
        onIndividualItemsClicked: this.onIndividualItemsClicked,
        onAllItemsClicked: this.onAllItemsClicked,
        selectableItems: items.filter(function (item) {
          return !selectedItems.includes(item.id);
        }),
        selectedItems: items.filter(function (item) {
          return selectedItems.includes(item.id);
        }),
        onSelect: this.selectItems,
        onSelectAll: this.selectItems,
        onDeselect: this.deselectItems,
        onDeselectAll: this.deselectItems,
        assignedItemsText: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
          id: "common.assigned",
          tagName: "span"
        }),
        notAssignedItemsText: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
          id: "common.notAssigned",
          tagName: "span"
        })
      });
    }
  }]);

  return CommonDualList;
}(_react.Component);

CommonDualList.propTypes = {
  allItemsSelected: _propTypes["default"].bool,
  selectedItems: _propTypes["default"].arrayOf(_propTypes["default"].number),
  items: _propTypes["default"].arrayOf(_propTypes["default"].shape()),
  onChange: _propTypes["default"].func
};
CommonDualList.defaultProps = {
  allItemsSelected: true,
  selectedItems: [],
  items: [],
  onChange: function onChange() {}
};
var _default = CommonDualList;
exports["default"] = _default;